import React from "react";
import House6 from "./Assets/Images/House6.webp";
import House9 from "./Assets/Images/House9.jpg";
import { FaCheck } from "react-icons/fa";

const OurServices = () => {
  return (
    <div className="w-full bg-black py-10 px-4 md:px-12 lg:px-20">
      {/* Header */}
      <div className="text-center max-w-5xl mx-auto">
        <h1 className="text-white text-3xl md:text-4xl font-extrabold font-sans mb-6">
          Our Services
        </h1>
        <p className="text-white mb-1">
          We offer a <b>comprehensive</b> suite of services designed to cater to
          both <b>Construction and Interior Design</b> needs. Whether you are
        </p>
        <p className="text-white mb-1">
          embarking on a <b>residential, commercial, or renovation project</b>,
          we ensure that each aspect of your space—<b>design</b>,
        </p>
        <p className="text-white mb-10">
          <b>construction, and functionality</b>—is carefully crafted to meet
          your needs.
        </p>
      </div>

      {/* Service Cards */}
      <div className="flex flex-col lg:flex-row gap-10" >
        {/* Construction */}
        <div className="bg-white p-6 rounded-md w-full lg:w-1/2" data-aos="zoom-in-right">
          <h2 className="text-black text-2xl md:text-3xl font-sans text-center font-semibold mb-4">
            Construction
          </h2>
          <img src={House6} alt="Construction" className="w-full rounded-md mb-4" />
          <p className="text-gray-800 mb-4">
            At <b>Ram Engineer</b>, we believe that exceptional design deserves
            to be paired with <b>exceptional construction</b>. Our construction
            services provide a <b>complete solution</b>, ensuring that your
            project is executed to the highest standards, <b>on time, and within budget</b>.
            We manage all aspects of the <b>construction process, ensuring quality</b> at every step.
          </p>
          <ul className="space-y-3">
            <li className="flex items-center gap-2" data-aos="fade-left" data-aos-delay="200">
              <FaCheck className="text-black-600" />
              <b>Residential Projects</b>
            </li>
            <li className="flex items-center gap-2" data-aos="fade-left" data-aos-delay="400">
              <FaCheck className="text-black-600" />
              <b>Commercial Buildings</b>
            </li>
            <li className="flex items-center gap-2" data-aos="fade-left" data-aos-delay="600">
              <FaCheck className="text-black-600" />
              <b>Renovations and Remodeling</b>
            </li>
            <li className="flex items-center gap-2" data-aos="fade-left" data-aos-delay="800">
              <FaCheck className="text-black-600" />
              <b>Civil Works and Architectural Planning</b>
            </li>
          </ul>
        </div>

        {/* Interior Design */}
        <div className="bg-white p-6 rounded-md w-full lg:w-1/2" data-aos="zoom-in-left">
          <h2 className="text-black text-2xl md:text-3xl font-sans text-center font-semibold mb-4">
            Interior Design
          </h2>
          <img src={House9} alt="Interior Design" className="w-full rounded-md mb-4" />
          <p className="text-gray-800 mb-4">
            <b>Interior design</b> is an art form that blends functionality with
            creativity. At <b>Ram Engineer</b>, we believe that interior spaces
            should be both <b>aesthetically pleasing and highly functional</b>.
            Our designs are personalized to reflect the unique tastes,
            <b>preferences, and needs of each client</b>, ensuring that your
            space not only looks good but works well for you.
          </p>
          <ul className="space-y-3">
            <li className="flex items-center gap-2" data-aos="fade-left" data-aos-delay="200">
              <FaCheck className="text-black-600" />
              <b>Modular Kitchens</b>
            </li>
            <li className="flex items-center gap-2" data-aos="fade-left" data-aos-delay="400">
              <FaCheck className="text-black-600" />
              <b>Wardrobes and Storage Solutions</b>
            </li>
            <li className="flex items-center gap-2" data-aos="fade-left" data-aos-delay="600">
              <FaCheck className="text-black-600" />
              <b>Bedrooms, Living Rooms, and Bathrooms</b>
            </li>
            <li className="flex items-center gap-2" data-aos="fade-left" data-aos-delay="800">
              <FaCheck className="text-black-600" />
              <b>Space-saving furniture and Home Offices</b>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default OurServices;
